import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { styled } from '@mui/material/styles';
import "./landing.css";
// import asplLogo from './Anmerkung.png';
import source from './SourceIMG.png';
import { TypeAnimation } from 'react-type-animation';
import CircularProgress from '@mui/material/CircularProgress';
// import video1 from '../comps/Backgroundvideo.mp4';

const Landing = () => {
  const video1 = "/Backgroundvideo.mp4";
  const history = useHistory();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedButton, setSelectedButton] = useState(null);
  const [loading, setLoading] = useState(false);

  const openModal = (button) => {
    setSelectedButton(button);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setSelectedButton(null);
    setModalIsOpen(false);
  };

  const Div = styled('div')(({ theme }) => ({
    ...theme.typography.button,
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(1),
    fontFamily: 'Montserrat'
  }));

  useEffect(() => {
    const unlisten = history.listen(() => {
      window.location.reload();
    });
    return () => {
      unlisten();
    };
  }, [history]);

  useEffect(() => {
    sessionStorage.clear();
  }, []);


  const handleTaskClick = () => {
    setLoading(true);
    setTimeout(() => {
      history.push('login')
    })
  }

  return (
    <div className="min-h-screen flex flex-col justify-center items-center landing-main-div">
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute top-0 left-0 w-full h-full object-cover -z-10"
      >
        {/* <source src={video1} type="video/mp4" />  */}
          <source src="https://demo-s3sourceoptima.s3.us-east-1.amazonaws.com/Backgroundvideo.mp4" type="video/mp4" />
      </video>
      <header className="w-full flex justify-between items-center p-5" style={{ height: "12vh", zIndex: "1" }}>
        <img className="header-logo" src={source} alt="Logo" style={{ height: "auto", width: "350px" }} />
        <div className="flex space-x-6 items-center ">
          <a href="#" className="font-medium text-2xl text-[#FECF8B]  transition duration-300">Solutions</a>
          <a href="#" className="font-medium text-2xl text-[#FECF8B]  transition duration-300">About</a>
          <a href="#" className="font-medium text-2xl text-[#FECF8B]  transition duration-300">Technology</a>

          <Link
            to="/login"
            className="font-medium text-xl bg-[#FECF8B] text-[#1E5045] px-6 py-2 rounded-xl hover:bg-[#FFD77D] transition duration-300"
          >
            Login
          </Link>
          <button
            onClick={handleTaskClick}
            className="font-medium text-xl text-orange-200 hover:text-green-500 transition duration-300"
            disabled={loading}
          ></button>
        </div>
      </header>
      <main className="flex-grow container mx-auto flex flex-col justify-center items-center p-4">
        {/* <Div style={{ background: 'transparent', color: 'white', fontSize: 35 }} className="title">{"turn your drawings to data"}</Div> */}
        <div style={{ background: 'transparent', color: '#efe7da', fontSize: 50, fontWeight: 'bold' }} className="title">
          <TypeAnimation
            sequence={[
              'TURN YOUR DRAWINGS TO DATA',
              1000,
            ]}
            wrapper="span"
            speed={30}
            repeat={Infinity}
            cursor={false}
          />
        </div>
        {loading && (
          <div className="absolute inset-0 flex justify-center items-center bg-opacity-75 bg-slate-500">
            <CircularProgress color="inherit" />
          </div>
        )}
        {/* <ul className="circles">
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul> */}
      </main>
      <footer className="w-full text-small text-center p-3 text-white bg-transparent">
        <p>&copy; SourceOptima. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default Landing;
